export const Specialities = [
  'Acute care',
  'Administration/Finance',
  'Allergy/Immunology',
  'Anesthesia',
  'Biomedical',
  'Cardiology',
  'Cath-Lab',
  'Critical Care',
  'Dermatology',
  'Dialysis',
  'Emergency Medicine',
  'Endocrinology',
  'ENT',
  'Gastroenterology',
  'GI Lab/Endoscopy',
  'Hematology',
  'Human Resources',
  'Infection Control',
  'Information Systems',
  'Internal Medicine',
  'Interventional Radiology',
  'IV Therapy',
  'Labor & Delivery',
  'Maint/Repair/Operations',
  'Materials Management',
  'Neurology',
  'NICU (Neonatal)',
  'Nursing',
  'OB-GYN',
  'Oncology',
  'Ophthalmology',
  'Optometrics',
  'Orthopedics',
  'Pain Management',
  'Pediatrics',
  'Pharmacy',
  'Physical Therapy',
  'Plastic Surgery',
  'Primary Care',
  'Psychiatry',
  'Radiology',
  'Rehab Facility',
  'Respiratory Therapy',
  'Surgery/O.R.',
  'Urology',
  'Wound Care',
]
export const Facilities = [
  'Alternate Site',
  'Clinic/Surgery Center',
  'Dental',
  'Government',
  'HMO/Managed Care',
  'Home Health/Home Infusion',
  'Hospital',
  'Laboratory',
  'Long Term Care',
  'Nursing Home',
  'Pharmacy',
  'Physician Office',
  'Rehabilitation',
  'Surgery',
  'Veterinary',
]
export const CompensationType = [
  'Salary+Commission',
  'Commission Only',
  'Salary Only',
  'Not Specified',
]
export const ProductCategory = [
  'Biotechnology',
  'Capital Equipment',
  'Consulting',
  'Diagnostic Imaging',
  'Distribution',
  'Durable Medical Equipment',
  'Healthcare IT',
  'Healthcare Software',
  'Maint/Repair/Operations',
  'Medical Devices',
  'Medical Disposables',
  'Pharmaceutical',
  'Services',
]
export const PrimaryFunction = [
  'Business Development',
  'Clinical Consultant',
  'Government Accounts',
  'Independent Rep',
  'International Sales',
  'Marketing',
  'National Accounts',
  'Sales',
  'Sales Management',
  'Sales Support',
  'Service Technician',
  'Telemarketing',
]
export const ExperienceLevel = [
  'Entry-Level 0-2 years',
  'Mid-Level 3-5 years',
  'Senior 6+ years',
  'Executive',
]

export const employmentType = [
  'Full Time',
  'Part Time',
  'Temporary',
  'Contract',
  'Freelance',
  'Intern',
  'Volunteer',
  'Job Share',
]
export const educationLevel = [
  'High School',
  'Associate',
  'Bachelors',
  'Masters',
  'Doctorate',
  'Other',
]
export const postedBy = ['Employer', 'Recruiter']
export const currency = [
  {
    name: 'USD',
    value: '$',
  },
]
export const emailFrequency = ['Daily', 'Weekly', 'Monthly', 'Never']
export const emailFrequencyCandidate = ['Daily', 'Weekly', 'Never']
export const emailFrequencyJobAlert = ['Daily', 'Weekly']
export const jobFunctions = [
  'Business Development',
  'Clinical Consulting',
  'Independent Representative',
  'Marketing',
  'Account Management',
  'National Accounts',
  'Sales',
  'Sales Management',
  'Sales Support',
  'Service Technician',
  'Other',
]
export const jobCategories = [
  'Biotechnology',
  'Capital Equipment',
  'Diagnostics',
  'Durable Medical Equipment',
  'Information Technology/Software',
  'Medical Device',
  'Medical Disposables',
  'Healthcare Services',
  'Pharmaceutical',
  'Other',
]
export const EMPLOYER_TYPES = ['Recruiting/Staffing Firm', 'Direct Employer']
export const TESTIMONIAL_SIGNUP = [
  {
    message:
      'Awesome experience will always come back here when the time comes to find a new job.',
    by: 'Ryan',
  },
  {
    message:
      'Medreps is great. It helped me find a new opportunity. I highly recommend to others.',
    by: 'Scott',
  },
  {
    message:
      'Great experience, found a job I’ve been in for 5+ years. I always recommend medreps',
    by: 'Garrett',
  },
  {
    message:
      'Very nice! Great way to find companies in the industry that I’ve not heard of.',
    by: 'King',
  },
  {
    message:
      'Perfect, I found my new job for LATAM market with Avante Health solutions company. Thanks.',
    by: 'Mariella',
  },
  {
    message: 'Amazing! Got into Medical Device because of this platform!!',
    by: 'Michael',
  },
]
export const jobTravelFunction = ['0-25%', '25-50%', '50-75%', '75-100%']
export const valuesSetHandler = value => {
  value = value.split(' + ').join('_p_')
  value = value.split('+').join('_p_')
  value = value.split(' / ').join('_or_')
  value = value.split('/').join('_or_')
  value = value.split('&').join('_and_')
  value = value.split(' ').join('_')
  value = value.split('-').join('_')
  return value
}

export const paramsReturnHandler = query => {
  if (query) {
    let search = query.substring(1)
    return JSON.parse(
      '{"' +
        decodeURI(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"') +
        '"}'
    )
  } else {
    return {}
  }
}
export const DEFAULT_JOB_SEARCH_MIN_COMPENSATION = 1
export const DEFAULT_JOB_SEARCH_MAX_COMPENSATION = 500

export const RESUME_SEARCH_EDUCATION_LEVEL_OPTIONS = [
  {
    value: 'High School',
    label: 'High School',
  },
  {
    value: 'Associate',
    label: 'Associate',
  },
  {
    value: 'Bachelors',
    label: 'Bachelors',
  },
  {
    value: 'Masters',
    label: 'Masters',
  },
  {
    value: 'Doctorate',
    label: 'Doctorate',
  },
  {
    value: 'Other',
    label: 'Other',
  },
]
export const RESUME_SEARCH_TOTAL_EXPERIENCE_OPTION = [0, 35]
export const RESUME_SEARCH_MEDICAL_EXPERIENCE_OPTION = [0, 35]
export const RESUME_SEARCH_WILLING_TRAVEL_OPTION = [0, 100]
export const RESUME_SEARCH_DISTANCE_OPTIONS = [
  {
    value: 'any',
    label: 'Within 0 Miles',
  },
  {
    value: '10',
    label: 'Within 10 Miles',
  },
  {
    value: '20',
    label: 'Within 20 Miles',
  },
  {
    value: '50',
    label: 'Within 50 Miles',
  },
  {
    value: '100',
    label: 'Within 100 Miles',
  },
  {
    value: '500',
    label: 'Within 500 Miles',
  },
]

export const SELECT_ALL = 'Select All'

export const ARTICLE_CATEGORY_ALL = 'All'

export const RESUME_SEARCH_SORT_BY_RELEVANCY = 'relevancy'
export const RESUME_SEARCH_SORT_BY_DATE = 'date'
export const JOB_SEARCH_SORT_BY_RELEVANCY = 'relevancy'
export const JOB_SEARCH_SORT_BY_DATE = 'date'

export const SANITIZE_DESCRIPTION = {
  allowedTags: [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'ul',
    'li',
    'ol',
    'p',
    'b',
    'i',
    'em',
    'strong',
    'a',
    'u',
    'br',
  ],
  allowedAttributes: {
    a: ['href'],
  },
  allowedIframeHostnames: [],
}

export const HUBSPOT_INTEGRATION = {
  PORTAL_ID: '8700794',
  CONTACT_FORM_ID: 'e8916269-f300-4e13-9a49-f5c630cabb3f',
  HIRING_CONTACT_FORM_ID: 'f70ad502-5bc7-47a4-81da-8182c456daa9',
  EMAIL_PREFERENCE_FORM_ID: '295b2502-a0e8-40e0-b562-5316a7c0897f',
  NEWSLETTER_FORM_ID: 'ec81ad20-d392-4b9e-b692-4e4502874363',
}

export const EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
